import { ApiProperty } from '@nestjs/swagger';
import { IsDateString, IsOptional, IsNumber, IsString } from 'class-validator';

/**
 * DTO para representar una temporada
 */
export class TemporadaDto {
  @ApiProperty({
    description: 'ID único de la temporada',
    example: 1,
  })
  @IsNumber()
  id!: number;

  @ApiProperty({
    description: 'Fecha de inicio de la temporada',
    example: '2024-11-01T00:00:00.000Z',
  })
  @IsDateString()
  fechaInicio!: string;

  @ApiProperty({
    description: 'Fecha de fin de la temporada',
    example: '2025-10-31T23:59:59.000Z',
  })
  @IsDateString()
  fechaFin!: string;

  @ApiProperty({
    description: 'Nombre o descripción de la temporada',
    example: 'Temporada 2024-2025',
    required: false,
  })
  @IsOptional()
  @IsString()
  nombre?: string;

  @ApiProperty({
    description: 'Estado de la temporada (1 = activa, 0 = inactiva)',
    example: 1,
  })
  @IsNumber()
  activa!: number;

  @ApiProperty({
    description: 'Usuario que creó la temporada',
    example: 'admin@opb.com',
    required: false,
  })
  @IsOptional()
  @IsString()
  createdBy?: string;

  @ApiProperty({
    description: 'Fecha de creación',
    example: '2024-01-01T00:00:00.000Z',
    required: false,
  })
  @IsOptional()
  @IsDateString()
  creationDate?: string;

  @ApiProperty({
    description: 'Usuario que actualizó la temporada',
    example: 'admin@opb.com',
    required: false,
  })
  @IsOptional()
  @IsString()
  updateBy?: string;

  @ApiProperty({
    description: 'Fecha de actualización',
    example: '2024-01-01T00:00:00.000Z',
    required: false,
  })
  @IsOptional()
  @IsDateString()
  updateDate?: string;
}

/**
 * DTO para buscar temporada por fecha
 */
export class BuscarTemporadaPorFechaDto {
  @ApiProperty({
    description: 'Fecha para buscar la temporada (formato: YYYY-MM-DD)',
    example: '2024-07-15',
  })
  @IsDateString()
  fecha!: string;
}

/**
 * DTO para buscar temporadas por rango de fechas
 */
export class BuscarTemporadasPorRangoDto {
  @ApiProperty({
    description: 'Fecha de inicio del rango (formato: YYYY-MM-DD)',
    example: '2024-01-01',
  })
  @IsDateString()
  fechaInicio!: string;

  @ApiProperty({
    description: 'Fecha de fin del rango (formato: YYYY-MM-DD)',
    example: '2024-12-31',
  })
  @IsDateString()
  fechaFin!: string;
}

/**
 * DTO para estadísticas de temporadas
 */
export class TemporadasStatsDto {
  @ApiProperty({
    description: 'Total de temporadas',
    example: 5,
  })
  @IsNumber()
  totalTemporadas!: number;

  @ApiProperty({
    description: 'Número de temporadas activas',
    example: 3,
  })
  @IsNumber()
  temporadasActivas!: number;

  @ApiProperty({
    description: 'Temporada actual (si existe)',
    required: false,
  })
  @IsOptional()
  temporadaActual?: TemporadaDto;

  @ApiProperty({
    description: 'Próxima temporada (si existe)',
    required: false,
  })
  @IsOptional()
  proximaTemporada?: TemporadaDto;
}
